/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { useGlobalState } from 'src/core/hooks/useGlobalState';
import { VersionedAppId } from 'src/luis/types/VersionedAppId';

/**
 * A hook used to get the current app id and current app version id.
 */
export const useCurrentVersionedAppId = (): VersionedAppId => {
    const { rootStore } = useGlobalState();
    const currentAppStore = rootStore.currentLuisAppStore;
    const currentAppVersionStore = currentAppStore?.currentAppVersionStore;

    if (currentAppStore && currentAppVersionStore) {
        return { appId: currentAppStore.id, versionId: currentAppVersionStore.id };
    }

    return { appId: undefined, versionId: undefined };
};
